<template>
<v-dialog
  v-model="dialog"
  hide-overlay
  max-width="450"
>
  <v-card v-if="dialog" class="justify-center py-10 text-center">
    <v-card-title class="h4 justify-center">{{ ctitle }}</v-card-title>

    <v-card-text>
      <slot :data="value.data"></slot>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn color="primary" @click="ok()">{{ $t(this.okButton) }}</v-btn>
      <v-btn color="error" @click="cancel()">{{ $t("Abbrechen") }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "Confirm",

  props: [
    "title",
    "value",
    "okButtonText"
  ],

  data() {
    return {
      dialog: false,
      cfg: {}
    };
  },

  computed: {
    ctitle() {
      if (this.title) {
        return this.title;
      }

      return this.value.title;
    },
    okButton() {
      if (this.okButtonText) {
        return this.okButtonText;
      }

      return "OK";
    }
  },

  watch: {
    value() {
      this.dialog = true;
    }
  },

  methods: {
    ok() {
      this.dialog = false;
      this.$emit("ok");
      if ("ok" in this.value) {
        this.value.ok();
      }
    },

    cancel() {
      this.dialog = false;
      this.$emit("cancel");
      if ("cancel" in this.value) {
        this.value.cancel();
      }
    }
  }
};
</script>
